export const spaces = {
  auto: "auto",
  none: "0px",
  xsmall: "3px",
  small: "8px",
  regular: "15px",
  medium: "24px",
  large: "32px",
  xlarge: "44px",
  xxlarge: "52px",
  xxxlarge: "64px",
};
